export default "void main() {\n    gl_FragColor = vec4(1.0);\n}\n";